import File from "@/Components/Base/File";
import TextfieldIntControlled from "@/Components/Input/TextfieldIntControlled";
import Select from "@/Components/Select/Select";
import { targetsWithoutAll } from "@/shared/utils/constant";
import { CategoryType } from "@/shared/utils/enum";
import { MenuDataTagKind } from "@/shared/utils/interfaces";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  asArray,
  guidGenerator,
  isFavoriteCategory,
} from "../../shared/utils/helpers";
import RadioButtonGroup from "../Input/RadioButtonGroup";
import Textfield from "../Input/Textfield";
import MenuDataTagFields from "./MenuDataTagFields";

const CategoryModalStandard = ({
  defaultValue,
  selectedFile,
  setSelectedFile,
  preview,
  setPreview,
}) => {
  const formContext = useFormContext();
  const { errors, register, control } = formContext;
  const { t } = useTranslation();

  useEffect(() => {
    selectedFile && setPreview(URL.createObjectURL(selectedFile));
  }, [selectedFile]);
  return (
    <div>
      <div className="mb-[2rem]">
        {!defaultValue?.item_id ? (
          <Controller
            name="virtual_item_type"
            control={control}
            defaultValue={
              defaultValue?.virtual_item_type ?? CategoryType.NORMAL
            }
            rules={{ required: true }}
            render={({ onChange, value }) => (
              <RadioButtonGroup
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
                options={[
                  {
                    value: CategoryType.NORMAL,
                    label: t("menu.normalCategory"),
                  },
                  {
                    value: CategoryType.FAVORITE,
                    label: t("menu.favoriteCategory"),
                  },
                ]}
              />
            )}
          />
        ) : (
          isFavoriteCategory(defaultValue?.virtual_item_type) && (
            <span className="text-error font-bold">
              {t("menu.favoriteCategory")}
            </span>
          )
        )}

        <Textfield
          hidden
          key={Date.now()}
          defaultValue={defaultValue?.code || guidGenerator()}
          name="code"
          error={errors?.code?.message}
          ref={register({})}
        />
        <File
          size="10rem"
          isDeletable
          onChange={(file) => setSelectedFile(file[0])}
          onClickDelete={() => {
            setPreview(null);
            setSelectedFile(null);
          }}
          src={preview}
        />

        <TextfieldIntControlled
          label={t("name")}
          required
          placeholder={t("menu.categoryName")}
          name="name"
          validationMessage={t("standardMustBeFilled")}
          defaultValue={defaultValue?.name}
        />
      </div>

      <TextfieldIntControlled
        label={t("description")}
        required={false}
        placeholder={t("menu.categoryDescription")}
        name="description"
        validationMessage={t("standardMustBeFilled")}
        defaultValue={defaultValue?.description}
      />

      <div className="my-[2rem]">
        <Controller
          name="target"
          control={control}
          rules={{
            required: { value: true, message: t("fieldRequired") },
          }}
          defaultValue={
            asArray(defaultValue?.target)?.map((target) =>
              targetsWithoutAll.find((i) => i.value === target)
            ) || targetsWithoutAll
          }
          render={({ onChange, value }) => (
            <Select
              menuPortalTarget={document.getElementById("root")}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              label={t("targets")}
              value={value}
              isMulti
              onChange={(v) => onChange(v)}
              options={targetsWithoutAll}
              optionLabel
              getOptionLabel={(option) => t(`${option.label}`)}
            />
          )}
        />
      </div>

      <div className="mb-[2rem]">
        <MenuDataTagFields
          kind={MenuDataTagKind.CATEGORY}
          defaultValue={defaultValue}
          showSize={false}
          showVariants={false}
        />
      </div>
    </div>
  );
};

export default CategoryModalStandard;
